/*
  Barre compteur / "Filtrer" de la page collection.

  Le sticky mobile est fait en CSS ; ce script ne fait que detecter le moment ou
  la barre est collee, ce que la CSS ne sait pas faire de facon portable, pour
  n'afficher le filet de separation qu'a ce moment-la. En desktop la barre est
  en display: contents, n'est pas sticky, et l'attribut n'est jamais pose.
*/
(() => {
  if (customElements.get('collection-toolbar')) return;

  class CollectionToolbar extends HTMLElement {
    connectedCallback() {
      this.onScroll = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.update();
        });
      };
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.update();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
    }

    update() {
      const style = getComputedStyle(this);
      const stuck =
        style.position === 'sticky' && this.getBoundingClientRect().top <= parseFloat(style.top) + 1;
      this.toggleAttribute('data-stuck', stuck);
    }
  }

  customElements.define('collection-toolbar', CollectionToolbar);
})();
